<!--
    迁入金额修改
-->
<style lang="less">
.account-migration-money-dialog {
  padding-bottom: @containerGap;
}
</style>

<template>
  <yg-modal
    width="600"
    title="迁入金额修改"
    :back-type="2"
    :sure-button-disabled="buttonDisabled"
    :sure-button-disabled-text="buttonDisabledMsg"
    @on-close="onClose"
    @on-sure="requestChange"
  >
    <div
      slot="content"
      class="account-migration-money-dialog"
    >
      <Form>
        <Alert
          type="info"
          show-icon
        >
          修改说明
          <div slot="desc">
            <p>1、修改「充值币」时需小于原始值。</p>
            <p>2、修改「迁入币」时可自行修改为任意值。</p>
          </div>
        </Alert>
        <FormItem
          v-if="item.isShow"
          v-for="(item, index) in formItems"
          :key="index"
          :label="item.label"
          :label-width="145"
          :required="item.isRequired"
        >
          <Input
            v-if="item.tagName === 'Input'"
            v-model="model[item.key]"
            type="text"
            :maxlength="item.maxLength"
            :placeholder="'请输入' + item.label"
            :disabled="item.disabled"
            @input="checkSubmit"
          />
          <RadioGroup
            v-else-if="item.tagName === 'Radio'"
            v-model="model[item.key]"
            @on-change="onChangeRadio"
          >
            <Radio
              v-for="(sub, j) in item.dataOptions"
              :key="j"
              :label="sub.value"
              :disabled="item.isDisabled"
            >
              {{ sub.label }}
            </Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </div>
  </yg-modal>
</template>

<script>

import CustomerApiSet from '@/request/api/CustomerApiSet';
import { isFloat } from '@/libs/regularUtils';

export default {
  components: {},
  mixins: [],
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      buttonDisabled: false,
      buttonDisabledMsg: '',
      // 表单数据
      formItems: [
        {
          label: '修改金额类型',
          key: 'adjustRecordType',
          tagName: 'Radio',
          disabled: false,
          isRequired: false,
          dataOptions: [
            { value: 1, label: '修改充值金额' },
            { value: 3, label: '修改迁入金额' }
          ],
          isShow: true
        },
        {
          label: '原迁入金额',
          key: 'migrationMoney',
          tagName: 'Input',
          disabled: true,
          isRequired: false,
          isShow: true
        },
        {
          label: '修改后的迁入金额',
          key: 'newMigrationMoney',
          tagName: 'Input',
          disabled: false,
          isRequired: false,
          isShow: true
        },
        {
          label: '原充值金额',
          key: 'rechargeMoney',
          tagName: 'Input',
          disabled: true,
          isRequired: false,
          isShow: true
        },
        {
          label: '修改后的充值金额',
          key: 'newRechargeMoney',
          tagName: 'Input',
          disabled: false,
          isRequired: false,
          isShow: true
        }
      ]
    };
  },
  created () {
    console.log(this.model, 111);
    this.onChangeRadio(this.model.adjustRecordType);
    // this.checkSubmit();
  },
  methods: {
    /** ******************* 工具方法开始 ******************* **/
    /** ******************* 工具方法结束 ******************* **/

    /** ******************* 回调事件开始 ******************* **/
    onClose () {
      this.$emit('on-close', false);
    },
    onChangeRadio (e) {
      this.formItems.forEach((item) => {
        if (item.key === 'migrationMoney' || item.key === 'newMigrationMoney') {
          item.isShow = e === 3;
        } else if (item.key === 'rechargeMoney' || item.key === 'newRechargeMoney') {
          item.isShow = e === 1;
        }

        this.model.newRechargeMoney = '';
        this.model.newMigrationMoney = '';
      });
    },
    /** ******************* 回调事件结束 ******************* **/

    /** ******************* 点击事件开始 ******************* **/
    // 检查必填项
    checkSubmit () {
      if (this.model.adjustRecordType === 1) {
        // 充值
        const newRechargeMoney = this.model.newRechargeMoney;
        this.buttonDisabled = !isFloat(newRechargeMoney);
        this.buttonDisabledMsg = '修改后的金额请输入数字';
        /* if (newRechargeMoney > this.model.rechargeMoney) {
          this.buttonDisabled = true;
          this.buttonDisabledMsg = '充值金额不可大于原充值金额';
         } else */

        if (newRechargeMoney === this.model.rechargeMoney) {
          this.buttonDisabled = true;
          this.buttonDisabledMsg = '不可以与原金额一致！';
        }
      } else {
        const newMigrationMoney = this.model.newMigrationMoney;
        this.buttonDisabled = !isFloat(newMigrationMoney);
        this.buttonDisabledMsg = '修改后的金额请输入数字';
        if (newMigrationMoney === this.model.migrationMoney) {
          this.buttonDisabled = true;
          this.buttonDisabledMsg = '不可以与原金额一致！';
        }
      }
    },
    /** ******************* 点击事件结束 ******************* **/

    /** ******************* 数据请求开始 ******************* **/
    // 迁入币清0
    requestChange () {
      const api = CustomerApiSet.adjustAccountMoney;
      api.params = {
        tel: this.model.tel,
        adjustRecordType: this.model.adjustRecordType,
        adjustMoney: this.model.adjustRecordType === 1 ? this.model.newRechargeMoney : this.model.newMigrationMoney
      };
      this.$http(api).then(() => {
        this.$Message.success('操作成功');
        this.$emit('on-close', true);
      });
    }
    /** ******************* 数据请求结束 ******************* **/
  }
};
</script>
